import React from "react";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import {
  PanelSearchItemConfig as SearchItemConfig,
  type ButtonConfig,
} from "@ms/shared-components";

// 搜索项配置
export const searchItems: SearchItemConfig[] = [
  {
    name: "keyword",
    label: "关键词",
    type: "input",
    props: {
      placeholder: "请输入标签名称或描述",
      allowClear: true,
    },
  },
];

// 创建搜索按钮配置
export const createSearchButtons = (handlers: {
  handleSearchClick: () => void;
  handleReset: () => void;
}): ButtonConfig[] => [
  {
    key: "reset",
    icon: <ReloadOutlined />,
    text: "重置",
    onClick: handlers.handleReset,
    group: "primary",
  },
  {
    key: "search",
    text: "搜索",
    icon: <SearchOutlined />,
    type: "primary",
    onClick: handlers.handleSearchClick,
    group: "primary",
  },
];
